import { render } from "./RafflePage.vue?vue&type=template&id=45c0857a&scoped=true"
import script from "./RafflePage.vue?vue&type=script&lang=js"
export * from "./RafflePage.vue?vue&type=script&lang=js"

import "./RafflePage.vue?vue&type=style&index=0&id=45c0857a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c0857a"]])

export default __exports__